import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Inbox,
  KanbanSquare,
  Shirt,
  Sparkles,
  BarChart3,
  LogOut,
  Feather,
} from "lucide-react";
import { NAV } from "@/constants/testIds";
import { logout } from "@/lib/auth";
import SlaNudge from "@/components/saheli/SlaNudge";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, tid: NAV.dashboard },
  { to: "/inquiries", label: "Inquiries", icon: Inbox, tid: NAV.inquiries },
  { to: "/pipeline", label: "Order Pipeline", icon: KanbanSquare, tid: NAV.pipeline },
  { to: "/products", label: "Catalog", icon: Shirt, tid: NAV.products },
  { to: "/match", label: "Saheli Match", icon: Sparkles, tid: NAV.match },
  { to: "/reports", label: "Reports", icon: BarChart3, tid: NAV.reports },
];

export default function Layout({ user, children }) {
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };
  return (
    <div className="min-h-screen flex">
      <aside className="hidden md:flex md:flex-col w-64 shrink-0 border-r border-stone-200 bg-white/70 backdrop-blur-sm">
        <div className="px-6 py-6 border-b border-stone-200">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-terracotta text-white grid place-items-center shadow-sm">
              <Feather className="w-4.5 h-4.5" strokeWidth={2.25} />
            </div>
            <div>
              <div className="font-serif text-2xl leading-none text-stone-900">Saheli</div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-stone-400 mt-0.5">
                Silk Mart Sarees
              </div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.tid}
                className={({ isActive }) =>
                  `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors duration-200 ${
                    isActive
                      ? "bg-terracotta/10 text-terracotta font-medium"
                      : "text-stone-600 hover:bg-stone-100 hover:text-stone-900"
                  }`
                }
              >
                <Icon className="w-4 h-4" strokeWidth={2} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-stone-200">
          <div className="flex items-center gap-2 px-3 py-2">
            {user?.picture ? (
              <img
                src={user.picture}
                alt=""
                className="w-8 h-8 rounded-full object-cover border border-stone-200"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-stone-200 grid place-items-center text-xs text-stone-600">
                {(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <div className="text-sm text-stone-800 truncate">{user?.name || "Staff"}</div>
              <div className="text-[11px] text-stone-500 truncate">{user?.email}</div>
            </div>
            <button
              data-testid={NAV.logout}
              onClick={onLogout}
              className="p-1.5 rounded-md text-stone-500 hover:text-terracotta hover:bg-stone-100 transition-colors"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="max-w-[1400px] mx-auto p-6 lg:p-10">{children}</div>
      </main>
      <SlaNudge />
    </div>
  );
}
